function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 14.5C4.69531 14.5 2 11.8047 2 8.5C2 5.19531 4.69531 2.5 8 2.5C11.3047 2.5 14 5.19531 14 8.5C14 11.8047 11.3047 14.5 8 14.5ZM7.25 6.25C7.25 6.67188 7.57812 7 8 7C8.42188 7 8.75 6.67188 8.75 6.25C8.75 5.82812 8.42188 5.5 8 5.5C7.57812 5.5 7.25 5.82812 7.25 6.25ZM7.0625 7.75C6.75781 7.75 6.5 8.00781 6.5 8.3125C6.5 8.61719 6.75781 8.875 7.0625 8.875H7.625V10.375H7.0625C6.75781 10.375 6.5 10.6328 6.5 10.9375C6.5 11.2422 6.75781 11.5 7.0625 11.5H8.9375C9.24219 11.5 9.5 11.2422 9.5 10.9375C9.5 10.6328 9.24219 10.375 8.9375 10.375H8.75V8.3125C8.75 8.00781 8.49219 7.75 8.1875 7.75H7.0625Z",
  fill: "#006CA3"
});

function SvgInfoFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoFilled);
export default __webpack_public_path__ + "static/media/info-filled.094302de.svg";
export { ForwardRef as ReactComponent };